import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Col } from "react-bootstrap";
import { getavailability } from "../store/slices/roomType";
import ShowSkeleton from "../utils/helpers/skeleton";
import Moment from "moment";

const RoomsAvailability = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isloading, setisLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setisLoading(true);
    getRoomLists();
  }, []);

  const getRoomLists = () => {
    const roomId = id;
    let item = { roomId };
    dispatch(getavailability(item))
      .unwrap()
      .then((data) => {
        setData(data?.data);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  function cancel() {
    navigate(-1);
  }
  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Room Availability</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              onClick={cancel}
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Rooms
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Room Availability</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
          <Link
            to={`/admin/add-room-availability/${id}`}
            className="btn btn-primary text-md btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
          >
            <Icon
              icon="ic:baseline-plus"
              className="icon text-xl line-height-1"
            />
            Add Availability
          </Link>
        </div>
        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-0">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="d-flex align-items-center gap-10">
                        S.L
                      </div>
                    </th>

                    <th scope="col">Room</th>
                    <th scope="col">Price</th>
                    <th scope="col">From Date</th>
                    <th scope="col">To Date</th>

                    {/* <th scope="col" className="text-center">
                      Action
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          {index + 1}
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item?.roomId?.roomTypeId?.name}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item?.pricePerRoom}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {Moment.utc(item?.startDate).format("DD-MM-YYYY")}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {Moment.utc(item?.endDate).format("DD-MM-YYYY")}
                            </span>
                          </div>
                        </div>
                      </td>

                      {/* <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <Link
                            to={`/admin/edit-property/${item._id}`}
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                            }}
                            className="bg-warning-focus text-warning-600 bg-hover-warning-200 fw-medium d-flex justify-content-center align-items-center"
                          >
                            Edit
                          </Link>
                        </div>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomsAvailability;
